import type Component from "../Component.ts";
import {getSingleParameter} from "../JobObjectHelper.ts";

const RUN_ORCHESTRATION_COMPONENT_ID = 1785813072
const RUN_TRANSFORMATION_COMPONENT_ID = 1896325668
const RUN_JOB_SLOT = 2

interface RunJobComponent {
    targetJobName: string
}

export function runJobComponent(component: Component): RunJobComponent | undefined {
    if(component.implementationID !== RUN_ORCHESTRATION_COMPONENT_ID && component.implementationID !== RUN_TRANSFORMATION_COMPONENT_ID) return undefined
    return {
        targetJobName: getSingleParameter(component, RUN_JOB_SLOT) ?? "-- Unknown"
    }
}